import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = '/api/subscriptions';

export const fetchPlans = createAsyncThunk('subscriptions/fetch', async (_, { rejectWithValue }) => {
  try {
      const response = await axios.get(API_URL);
      return response.data;

  } catch (err) {
    // The response body IS the message. Without this, createAsyncThunk
    // keeps only err.message — literally "Request failed with status
    // code 400" — and the reason the server sent is thrown away.
    const body = err.response?.data;
    // Only an OBJECT body is a server explanation. nginx answers a 502 with
    // an HTML PAGE, which is truthy — passing it through made the reducer
    // store RTK's literal "Rejected" (its action.error.message for any
    // rejectWithValue), which reads worse than the status line it replaced.
    return rejectWithValue(
      body && typeof body === 'object' ? body : { error: err.message }
    );
  }
});

export const createPlan = createAsyncThunk('subscriptions/create', async (data, { rejectWithValue }) => {
  try {
      const response = await axios.post(API_URL, data);
      return response.data;

  } catch (err) {
    // The response body IS the message. Without this, createAsyncThunk
    // keeps only err.message — literally "Request failed with status
    // code 400" — and the reason the server sent is thrown away.
    const body = err.response?.data;
    // Only an OBJECT body is a server explanation. nginx answers a 502 with
    // an HTML PAGE, which is truthy — passing it through made the reducer
    // store RTK's literal "Rejected" (its action.error.message for any
    // rejectWithValue), which reads worse than the status line it replaced.
    return rejectWithValue(
      body && typeof body === 'object' ? body : { error: err.message }
    );
  }
});

export const updatePlan = createAsyncThunk('subscriptions/update', async ({ id, data }, { rejectWithValue }) => {
  try {
      const response = await axios.put(`${API_URL}/${id}`, data);
      return response.data;

  } catch (err) {
    // The response body IS the message. Without this, createAsyncThunk
    // keeps only err.message — literally "Request failed with status
    // code 400" — and the reason the server sent is thrown away.
    const body = err.response?.data;
    // Only an OBJECT body is a server explanation. nginx answers a 502 with
    // an HTML PAGE, which is truthy — passing it through made the reducer
    // store RTK's literal "Rejected" (its action.error.message for any
    // rejectWithValue), which reads worse than the status line it replaced.
    return rejectWithValue(
      body && typeof body === 'object' ? body : { error: err.message }
    );
  }
});

export const deletePlan = createAsyncThunk('subscriptions/delete', async (id, { rejectWithValue }) => {
  try {
      await axios.delete(`${API_URL}/${id}`);
      return id;

  } catch (err) {
    // The response body IS the message. Without this, createAsyncThunk
    // keeps only err.message — literally "Request failed with status
    // code 400" — and the reason the server sent is thrown away.
    const body = err.response?.data;
    // Only an OBJECT body is a server explanation. nginx answers a 502 with
    // an HTML PAGE, which is truthy — passing it through made the reducer
    // store RTK's literal "Rejected" (its action.error.message for any
    // rejectWithValue), which reads worse than the status line it replaced.
    return rejectWithValue(
      body && typeof body === 'object' ? body : { error: err.message }
    );
  }
});

const subscriptionsSlice = createSlice({
    name: 'subscriptions',
    initialState: {
        items: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPlans.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchPlans.fulfilled, (state, action) => {
                state.loading = false;
                state.items = action.payload.data;
            })
            .addCase(fetchPlans.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.error || action.payload?.message || action.error.message;
            })
            .addCase(createPlan.fulfilled, (state, action) => {
                state.items.push(action.payload.data);
            })
            .addCase(updatePlan.fulfilled, (state, action) => {
                const index = state.items.findIndex(p => p.id === action.payload.data.id);
                if (index !== -1) {
                    state.items[index] = action.payload.data;
                }
            })
            .addCase(deletePlan.fulfilled, (state, action) => {
                state.items = state.items.filter(p => p.id !== action.payload);
            });
    },
});

export default subscriptionsSlice.reducer;
